var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2109 16.6448C29.3023 16.4348 29.3483 16.219 29.3483 16.0032C29.3483 16.0028 29.3483 16.0023 29.3483 16.0023C29.3483 16.2185 29.3023 16.4343 29.2109 16.6448Z",
    fill: "#C0C0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9004 16.7049C28.9004 16.5035 28.9997 16.3022 28.9997 16.1008C28.9997 16.3022 28.9997 16.5035 28.9004 16.7049Z",
    fill: "#C0C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95703 1H22.0528L28.7037 7.74499V26.5706",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2809 11.3691C18.2809 11.3691 18.2809 11.4697 18.3802 11.4697H24.1376V11.067C24.1376 10.8657 24.1376 10.5637 23.8398 10.463L19.1743 5.73146C18.9758 5.53011 18.7772 5.42944 18.5787 5.42944H18.1816V11.2684L18.2809 11.3691Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4782 13.584C17.287 13.584 16.3936 12.5773 16.3936 11.4699V5.53027H4.18385C2.99266 5.53027 2 6.53699 2 7.74505V28.7854C2 29.9934 2.99266 31.0002 4.18385 31.0002H22.0518C23.243 31.0002 24.2356 29.9934 24.2356 28.7854V13.584H18.4782Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.fec9f7ba59706dd88437592cb2da14d7.svg";
export { ForwardRef as ReactComponent };